<template>
    <div class="done-block">
        <div class="done-icon">
            <img src="../../../assets/check-icon.svg" alt="">
        </div>
        <div class="done-title">
            <h3>{{titleText}}</h3>
            <h3>{{titleBody}}</h3>
        </div>
        <div class="done-link">
            <p>Here is <span><span v-if="!custom_url">the</span> <span v-if="!!custom_url">are</span> </span> link<span v-if="!!custom_url">s</span>:</p>
            <div class="done-link-item">
              <a target="_blank"
                 :href="url_head + '/'+url">
                <span>{{url_head}}/{{url}}</span>
              </a>
              <VueCustomTooltip :position="getWidth > 991 ? 'is-right' : 'is-bottom'"
                                :label="tooltipTexts.url"
                                abbreviation>
                <button class="copy-button"
                        v-clipboard:copy="url_head + '/'+url"
                        @click="changeTooltipText('url')"
                        type="button">
                  <img src="../../../assets/copy.svg" alt="">
                </button>
              </VueCustomTooltip>
            </div>
            <div v-if="custom_url" class="done-link-item">
              <a target="_blank"
                 :href="url_head+'/' + custom_url">
                {{ url_head + '/' + custom_url }}
              </a>
              <VueCustomTooltip :position="getWidth > 991 ? 'is-right' : 'is-bottom'"
                                :label="tooltipTexts.custom_url"
                                abbreviation>
                <button class="copy-button"
                        v-clipboard:copy="url_head+'/' + custom_url"
                        @click="changeTooltipText('custom_url')"
                        type="button">
                  <img src="../../../assets/copy.svg" alt="">
                </button>
              </VueCustomTooltip>
            </div>
        </div>
    </div>
</template>
<style lang="sass">
    .done-block
        display: flex
        flex-direction: column
        align-items: center
        .done-icon
            display: flex
            flex-direction: column
            align-items: center
            img
                width: 60px
        .done-title
            display: flex
            flex-direction: column
            align-items: center
            padding: 20px 0
            h3
                margin: 0
                text-transform: uppercase
                font-size: 1.5em
                font-family: "Montserrat", sans-serif
        .done-link
            display: flex
            flex-direction: column
            align-items: center
            text-align: center
            word-break: break-all
            &-item
              display: flex
              align-items: center
              padding: 5px 0
            .copy-button
              height: 24px
              width: 24px
              background: transparent
              display: flex
              align-items: center
              justify-content: center
              padding: 0 0 0 10px

            p
                font-weight: 600
            a
                color: #2697e3
                display: flex
                align-items: center
                // margin: 10px 0 0 0
                cursor: pointer
                font-weight: 500
                span
                    margin: 0 5px
                svg
                    margin: 0 5px

</style>
<script>
import { mapGetters } from "vuex"
import Vue from "vue";
export default Vue.extend({
    name: 'DoneBlock',
    data () {
      return {
        tooltipTexts: {
          url: 'Copy to clipboard',
          custom_url: 'Copy to clipboard'
        }
      }
    },
    props: {
        url: {
            type: String,
            default: null
        },
        titleText: {
            type: String,
            default: 'Published!'
        },
        titleBody: {
            type: String,
            default: 'Your campaign is ready!'
        },
        custom_url: {
            type: String,
            default: null
        }
    },
    methods: {
      link(id) {
        return process.env.VUE_APP_URL + `/${id}`
      },
      changeTooltipText(link) {
        if (link === 'url') {
          this.tooltipTexts.url = 'Copied!'
          this.tooltipTexts.custom_url = 'Copy to clipboard!'
        }
        if (link === 'custom_url') {
          this.tooltipTexts.url = 'Copy to clipboard!'
          this.tooltipTexts.custom_url = 'Copied!'
        }
      }
    },
    computed: {
      ...mapGetters(['getWidth']),
        url_head() {
            return process.env.VUE_APP_URL
        }
    }
})
</script>
